import httpclient from './httpclient'
import md5 from 'js-md5'

export default {
    install: (Vue) => {
        Vue['hc'] = httpclient;
        Vue.prototype.$hc = httpclient;
        Vue.prototype.$md5 = md5;
    }
}